module.exports = __webpack_public_path__ + "angle-left.3ibSLItl.svg";